// # #############################################
// # Title : Spider Chart
// # Authors : Rohit, Mahesh, Shubham, Anoop, Sameer
// # Date : 15th October 2019
// # Last Modified : Shubham, September 2019
// # Version : 19.10.03
// # Description : This is the code for rendering a spider chart
// # ############################################

import React, { Component } from 'react';
import { ResponsiveRadar } from '@nivo/radar';

class SpiderChart extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: Array.isArray(this.props.compData) ? this.props.compData : [],
            colors: ["#2f32d1", "#EFE093", "#E1B675", "#DFA58B", "#D8CFAB", "#A7A19E", "#D3DB8D"]
            // default chart data - comment previus line and uncomment lines below to test
            // data: [{"name":"health","Competitor_3":1,"Competitor_1":7,"Competitor_2":4,"Your Brand":5},
            // {"name":"pleasure","Competitor_3":1,"Competitor_1":2,"Competitor_2":6,"Your Brand":5},
            // {"name":"taste","Competitor_3":1,"Competitor_1":4,"Competitor_2":4,"Your Brand":5}]
        }
    }

    componentDidUpdate(oldProps) {
        const newProps = this.props
        if (oldProps.compData !== newProps.compData) {
            this.setState({
                data: newProps.compData,
                colors: newProps.colors
            })
        }
    }



    render() {

        const LabelComponent = ({ id, anchor }) => (
            <g transform={`translate(${anchor === 'end' ? -30 : anchor === 'middle' ? -15 : 0}, -10)`}>
                <text
                    style={{
                        fontSize: "0.8rem",
                        fontWeight: 'bold',
                        fill: '#504331',
                    }}
                >
                    {id}
                </text>
            </g>
        );

        let newChartData  = this.state.data

        if (this.state.data.length > 0) {
            return (
                <div style={{ height: this.props.openScenario ? "15vh" : "100%" }}>
                    <ResponsiveRadar
                        data={newChartData}
                        keys={Object.keys(this.state.data[0]).slice(1, Object.keys(this.state.data[0]).length)}
                        indexBy="name"
                        maxValue="auto"
                        margin={{
                            "top": 15,
                            "right": 30,
                            "bottom": -10,
                            "left": 5
                        }}
                        curve="linearClosed"
                        borderWidth={2}
                        borderColor={{
                            "from": "color",
                            "modifiers": []
                        }}
                        gridLevels={5}
                        gridShape="circular"
                        enableDots={false}
                        dotSize={5}
                        dotColor={{
                            "theme": "background"
                        }}
                        dotBorderWidth={2}
                        dotBorderColor={{
                            "from": "color"
                        }}
                        enableDotLabel={false}
                        dotLabel="value"
                        dotLabelYOffset={-12}
                        colors={
                            this.state.colors
                        }
                        fillOpacity={0.1}
                        blendMode="multiply"
                        animate={true}
                        motionStiffness={90}
                        motionDamping={15}
                        isInteractive={true}
                        gridLabel={LabelComponent}
                        gridLabelOffset={-10}
                    // legends={[
                    //     {
                    //         "anchor": "top-left",
                    //         "direction": "column",
                    //         "translateX": -50,
                    //         "translateY": -40,
                    //         "itemWidth": 80,
                    //         "itemHeight": 20,
                    //         "itemTextColor": "#999",
                    //         "symbolSize": 12,
                    //         "symbolShape": "circle",
                    //         "effects": [
                    //             {
                    //                 "on": "hover",
                    //                 "style": {
                    //                     "itemTextColor": "#000"
                    //                 }
                    //             }
                    //         ]
                    //     }
                    // ]}
                    />

                </div>

            );

        } else {
            return (
                <div className="noSimText">
                    No data available for Radar chart
                </div>
            )
        }
    }
}

export default SpiderChart;
